/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type genericSavedReportConductor_savedReport$ref: FragmentReference;
declare export opaque type genericSavedReportConductor_savedReport$fragmentType: genericSavedReportConductor_savedReport$ref;
export type genericSavedReportConductor_savedReport = {|
  +id: string,
  +updatedAt: ?string,
  +updatedBy: ?{|
    +id: string,
    +fullName: ?string,
  |},
  +type: ?string,
  +name: ?string,
  +person: ?{|
    +id: string,
    +active: ?boolean,
  |},
  +groupingOne: ?string,
  +groupingTwo: ?string,
  +eyeApplied: ?string,
  +filterApplied: ?string,
  +startDate: ?string,
  +endDate: ?string,
  +periodType: ?string,
  +periodDate: ?string,
  +$refType: genericSavedReportConductor_savedReport$ref,
|};
export type genericSavedReportConductor_savedReport$data = genericSavedReportConductor_savedReport;
export type genericSavedReportConductor_savedReport$key = {
  +$data?: genericSavedReportConductor_savedReport$data,
  +$fragmentRefs: genericSavedReportConductor_savedReport$ref,
  ...
};
*/


const node/*: ReaderInlineDataFragment*/ = {
  "kind": "InlineDataFragment",
  "name": "genericSavedReportConductor_savedReport"
};
// prettier-ignore
(node/*: any*/).hash = '8772338c63555edb80319f4787b64fca';

module.exports = node;
